import { Header, IconWrapper, Inputs, MainBlock } from './styles';

import { CircleHelp } from 'lucide-react';
import { useCallback } from 'react';
import UDText from 'ud-ui/components/text';
import SizeItem from './size-item';
import { MANUAL } from 'shared/constants/links';

interface IProps {
  readonly: boolean;
}

function SizeInputs(props: IProps) {
  const redirectToManual = useCallback(() => {
    window.open(MANUAL, '_blank');
  }, []);

  return (
    <MainBlock>
      <Header>
        <UDText type={'caption-1'} className={'text-Black24 flex-center'}>
          Укажите размер экрана/холста
        </UDText>
        <IconWrapper onClick={redirectToManual}>
          <CircleHelp size={16} />
        </IconWrapper>
      </Header>
      <Inputs>
        <SizeItem readonly={props.readonly} name={'width'} text={'Ширина'} type={'text'} />
        <SizeItem readonly={props.readonly} name={'height'} text={'Высота'} type={'text'} />
      </Inputs>
    </MainBlock>
  );
}

export default SizeInputs;
